import { Button, Stack, Typography } from "@mui/material";
import WhiteCard from "../WhiteCard";
import { useMemo } from "react";
import Spinner from "../Spinner";
import Subscription from "./components/Subscription";
import { useGetPatientSubscriptionsByIdQuery } from "src/api/services/subscriptionsApi";
import { useSubscriptionModal } from "src/context/SubscriptionModalProvider/useSubscriptionModal";

interface Props {
  patientId: number;
  allowActions?: boolean;
}
const PatientSubscriptions = ({ patientId, allowActions = false }: Props) => {
  const { data, isLoading } = useGetPatientSubscriptionsByIdQuery(patientId);
  const { handleOpenCreatePlan } = useSubscriptionModal();

  const patientSubscriptions = useMemo(() => {
    if (data == null) return [];

    return data;
  }, [data]);

  return (
    <WhiteCard
      width="320px"
      maxHeight="315px"
      gap={1}
      sx={{ overflowY: "auto" }}
    >
      <Typography variant="subtitle2">SUBSCRIPTIONS</Typography>
      {isLoading ? (
        <Spinner />
      ) : patientSubscriptions.length <= 0 ? (
        <Typography>Patient has no subscriptions at this time.</Typography>
      ) : (
        <Stack gap={1}>
          {patientSubscriptions.map((sub) => (
            <Subscription
              subscription={sub}
              key={sub.id}
              allowActions={allowActions}
            />
          ))}
        </Stack>
      )}
      {allowActions ? (
        <Button
          variant="text"
          sx={{ alignSelf: "start" }}
          onClick={handleOpenCreatePlan}
        >
          {" "}
          + Create
        </Button>
      ) : null}
    </WhiteCard>
  );
};

export default PatientSubscriptions;
